import { EMIMETypes } from '@enums/common';
import { EDropzoneFileErrorCodes } from '@enums/dropzone';

export const acceptedAssetFileTypes = {
	[EMIMETypes.csv]: ['.csv'],
	[EMIMETypes.xls]: ['.xls'],
	[EMIMETypes.xlsx]: ['.xlsx'],
};

export const acceptedSitesFileTypes = {
	[EMIMETypes.csv]: ['.csv'],
	[EMIMETypes.xls]: ['.xls'],
	[EMIMETypes.xlsx]: ['.xlsx'],
};

export const acceptedPolygonFileTypes = {
	[EMIMETypes.csv]: ['.csv'],
	[EMIMETypes.kml]: ['.kml'],
	[EMIMETypes.zip]: ['.zip'],
};

export const assetFileErrors = {
	[EDropzoneFileErrorCodes.tooManyFiles]: 'Only one file can be uploaded',
	[EDropzoneFileErrorCodes.fileInvalidType]: 'Extension is not supported. Supports: CSV, XLS, XLSX',
};

export const siteFileErrors = {
	[EDropzoneFileErrorCodes.tooManyFiles]: 'Only one file can be uploaded',
	[EDropzoneFileErrorCodes.fileInvalidType]: 'Extension is not supported. Supports: CSV, XLS, XLSX',
};

export const polygonFileErrors = {
	[EDropzoneFileErrorCodes.tooManyFiles]: 'Only one file can be uploaded',
	[EDropzoneFileErrorCodes.fileInvalidType]: 'Extension is not supported. Supports: CSV, KML, ZIP',
};

export const supportedFilesForAssetsDescription = 'Supports: CSV, XLS, XLSX';
export const supportedFilesForSitesDescription = 'Supports: CSV, XLS, XLSX';
export const supportedFilesForPolygonsDescription = 'Supports: CSV, KML, SHAPE';
export const uploadedText = 'The file will be parsed using the character set UTF-8';
export const uploadAssetsDescription = 'You can import up to 5000 records through an XLS, XLSX.\n To import more than' +
	' 5000 records at a time use CSV.';
export const uploadSitesDescription = 'You can import up to 5000 records through an XLS, XLSX.\n To import more than' +
	' 5000 records at a time use CSV.';
export const uploadPolygonsDescription = 'To import more than 5000 records at a time use CSV.';

export const MAX_FILES = 1;
